var React = require('react');

function CatchesCheck (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"27.5","cy":"27.5","r":"27.5","fill":"#67C57A","key":0}),React.createElement("path",{"d":"M16.6118 23.6556L12.2432 27.5801L23.4748 40.0917L43.9203 14.3895L39.3166 10.7327L23.2071 30.9888L16.6118 23.6556Z","fill":"#BBEFFF","key":1})]);
}

CatchesCheck.defaultProps = {"width":"45","height":"45","viewBox":"0 0 55 55","fill":"none"};

module.exports = CatchesCheck;

CatchesCheck.default = CatchesCheck;
